<template>
<!-- 积分商城 -->
<section class="viewContainer">
  <div v-show="!pointsMallDia">
    <!--工具条-->
    <div class="main_container">
      <div class="fuji" @click="show3 = !show3">
        <div class="goodslist1">
          <span style="margin-left: 20px; margin-top: 5px">搜索/查询</span>
          <span class="divReset" @click.stop="fnReset"><img src="../../assets/img/Reset.png" alt/></span>
        </div>
        <div class="sanjiao" style="position: absolute; right: 0; top: -10px"></div>
      </div>
      <!-- 顶部搜索框 -->
      <el-collapse-transition>
      <div v-show="show3">
        <el-form :model="filters" class="findform">
          <el-form-item label="关键词：" style="display: flex; width: 30%">
            <el-input v-model="filters.name" maxlength="10" placeholder="请输入商品名称" style="width:90%"/>
          </el-form-item>
          <el-form-item label="品 类：" style="display: flex; width: 30%">
            <el-select v-model="filters.brandTypeId" filterable placeholder="请选择品类"
              ref="mySelect" @change="getbrandarr" style="width:90%">
              <el-option v-for="(item,index) in brandTypearr" :key="index" :value="item.Id" :label="item.Name"/>
            </el-select>
          </el-form-item>
          <el-form-item label="品 牌：" style="display: flex; width: 30%">
          <el-select v-model="filters.brandId" filterable placeholder="请选择" style="width:90%" ref="mySelect1">
              <el-option v-for="(item,index) in brandarr" :key="index" :value="item.Id" :label="item.Name"/>
              <!-- <el-option label="小程序" value="beijing"></el-option> -->
            </el-select>
          </el-form-item>
        </el-form>
        <el-form :model="filters" class="findform">
          <el-form-item label="状　态：" style="display: flex; width: 30%">
            <el-select v-model="filters.status" filterable placeholder="请选择" style="width:90%" ref="mySelect1">
              <el-option v-for="(item, index) in statedarr" :key="index" :value="item.Id" :label="item.Name"/>
              <!-- <el-option label="小程序" value="beijing"></el-option> -->
            </el-select>
          </el-form-item>
          <el-form-item label="商品类型：" style="display: flex; width: 30%">
            <!-- <el-button style="float:right;height:36px;line-height:1px" @click="onSubmit" class="toolbar_search">查询</el-button> -->
            <el-select v-model="filters.type" placeholder="请选择商品类型" filterable style="width:90%" ref="mySelect1">
              <el-option v-for="(item, index) in dada" :key="index" :value="item.value" :label="item.label"/>
            </el-select>
          </el-form-item>
          <el-form-item> <el-button type="danger" @click="onSubmit">查询</el-button> </el-form-item>
        </el-form>
      </div>
      </el-collapse-transition>
    </div>
    <!-- 列表 -->
    <div class="main_container">
      <section class="model_section">
        <p class="model_top_title">积分商城</p>
        <div style="float: right;margin-right: 10px;">
          <!-- v-if="menuAction.indexOf(117)>-1&&(userType == 5||BbId == 1)" -->
          <!-- v-if="menuAction.indexOf(1214)>-1" -->
          <!-- v-if="menuAction.indexOf(1215)>-1" -->
          <el-button type="danger" @click="goodsIsOnSale(1)"> 上 架 </el-button>
          <el-button type="danger" @click="goodsIsOnSale(0)"> 下 架 </el-button>
          <el-button type="danger" @click="eidtPointsMall(true)"> 新 增 </el-button>
        </div>
      </section>
      <div class="table_container">
        <el-table :data="imageData" stripe border @selection-change="handleSelectionChange">
          <el-table-column type="selection" align="center" width="55"/>
          <el-table-column label="序号" align="center" width="60px">
            <template scope="scope">{{scope.$index + 1}}</template>
          </el-table-column>
          <el-table-column label="商品类型" prop="typeName" align="center">
            <template scope="scope">
              <span :title="scope.row.typeName">{{ scope.row.typeName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="产品型号" prop="goodModelCode" align="center">
            <template scope="scope">
              <span :title="scope.row.goodModelCode">{{ scope.row.goodModelCode }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="名称" align="center">
            <template scope="scope">
              <span class="spanList" :title="scope.row.name">{{ scope.row.name }}</span>
            </template>
          </el-table-column>
          <el-table-column label="所属品牌商" prop="bbName" align="center">
            <template scope="scope">
              <span class="spanList" :title="scope.row.bbName">{{ scope.row.bbName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="品类" prop="goodsBrandTypeName" align="center">
            <template scope="scope">
              <span :title="scope.row.goodsBrandTypeName">{{ scope.row.goodsBrandTypeName }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="brandName" label="品牌" align="center">
            <template scope="scope">
              <span :title="scope.row.brandName">{{ scope.row.brandName }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="number" label="库存" align="center" width="80px">
            <template scope="scope">
              <span :title="scope.row.number">{{ scope.row.number }}</span>
            </template>
          </el-table-column>
          <el-table-column label="换购积分" prop="integral" align="center">
            <template scope="scope">
              <span class="spanList" :title="scope.row.integral">{{ scope.row.integral }}</span>
            </template>
          </el-table-column>
          <el-table-column label="换购记录" prop="exchangeCount" align="center" width="80px">
            <template scope="scope">
              <span :title="scope.row.exchangeCount" @click="exchangeNum(scope.row)"
              :style="{ color: scope.row.exchangeCount == '0' ? '#ccc' : '#6786b4', }">{{ scope.row.exchangeCount }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="stateName" label="状态" align="center" width="80px">
            <template scope="scope">
              <span :title="scope.row.stateName" :class="{ red: scope.row.stateName == '过期' }">
                {{ scope.row.stateName }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" align="center" width="240px">
            <template scope="scope">
              <div class="action_container">
                <!-- v-if="menuAction.indexOf(118)>-1&&scope.row.Id != 1&&(scope.row.StatusId == 1||scope.row.StatusId == 2||scope.row.StatusId == 3)" -->
                <p class="handle" v-if="scope.row.state!=1" @click="eidtPointsMall(false, scope.row)">
                  <i class="el-icon-edit-outline"></i> 编辑
                </p>
                <p @click="upordown(1, scope.row)" style="color: #6786b4; margin-left: 8px; cursor: pointer;">
                  <i class="el-icon-upload2" />向上
                </p>
                <p @click="upordown(2, scope.row)" style="color: #6786b4; margin-left: 8px; cursor: pointer;">
                  <i class="el-icon-download" />向下
                </p>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange"
        :page-size="10" :current-page="pageIndex" :total="total" style="margin: 10px 0;float: right"/>
      </div>
    </div>
  </div>

  <!-- 新增/编辑弹框  :fullscreen="true" :modal="false"-->
  <div class="main_container" v-if="pointsMallDia">
    <section class="model_section">
      <p class="model_top_title"> 新增/编辑商品 </p>
      <el-button type="danger" @click="cancelAdd()" style="float: right;margin: 5px 10px 0 0;">关闭</el-button>
    </section>
    <div style="width: 90%;margin: 30px auto;">
      <el-form :model="addGoodsForm" ref="addGoodsForm" label-width="100px" class="demo-ruleForm">
        <!-- 所属城市 -->
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="所属城市:" prop="preCity">
              <el-cascader v-model="addGoodsForm.preCity" :options="options" placeholder="请选择所属城市"
              filterable clearable :disabled="!pointsType" @change="handleChange" style="width: 100%"/>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="商品类型:" prop="type">
              <el-radio-group v-model="addGoodsForm.type" @change="radioType" :disabled="!pointsType">
                <el-radio :label="1">商品</el-radio>
                <el-radio :label="2">优惠券</el-radio>
                <el-radio :label="3">现金礼包</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>

        <template v-if="addGoodsForm.type">
          <el-row :gutter="20" v-if="addGoodsForm.type == 1">
            <el-col :span="8">
              <!-- <el-form-item label="商品:" prop="goods">
                <el-cascader v-model="addGoodsForm.goods" :options="goodsList" :props="optionProps" :disabled="!pointsType"
                  placeholder="请选择商品" style="width: 100%"
                  filterable clearable :key="goodsKey" @change="handleGoodsChange" popper-class="maxCascaderWidth"/>
              </el-form-item> -->
              <el-form-item label="店铺:">
                <el-select v-model="addGoodsForm.dianpu" placeholder="请选择" style="background:#fff;width:100%" @change="changeDp">
                  <el-option v-for="(item,index) in dianpuOptions" :key="index" :value="item.id" :label="item.name"/>
                </el-select>
              </el-form-item>
              <el-form-item label="品类:">
                <el-select v-model="addGoodsForm.dlpl" placeholder="请选择" style="background:#fff;width:100%" @change="changepl">
                  <el-option v-for="(item,index) in dlplOptions" :key="index" :value="item.id" :label="item.name"/>
                </el-select>
              </el-form-item>
              <el-form-item label="品牌:">
                <el-select v-model="addGoodsForm.dlpp" placeholder="请选择" style="background:#fff;width:100%" @change="changepp">
                  <el-option v-for="(item,index) in dlppOptions" :key="index" :value="item.id" :label="item.name"/>
                </el-select>
              </el-form-item>
              <el-form-item label="商品:">
                <el-select v-model="addGoodsForm.shangpin" placeholder="请选择" style="background:#fff;width:100%">
                  <el-option v-for="(item,index) in shangpinOptions" :key="index" :value="item.id" :label="item.name"/>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20" v-if="addGoodsForm.type == 2">
            <el-col :span="8">
              <el-form-item label="优惠券:" prop="couponId">
                <el-cascader v-model="addGoodsForm.couponId" :options="couponsList" :disabled="!pointsType"
                :props="optionCouponProps" :key="couponKey" placeholder="请选择优惠券" filterable clearable
                @change="handleCouponsChange" popper-class="maxCascaderWidth" style="width: 100%"/>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 现金礼包 -->
          <el-row :gutter="20" v-if="addGoodsForm.type == 3">
            <el-col :span="8">
              <el-form-item label="现金礼包面值:" prop="faceValue">
                <el-input v-model="addGoodsForm.faceValue" placeholder="请输入金额（元）" maxlength="10"
                  width="100%" onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="可兑换数量:" prop="number">
                <el-input v-model="addGoodsForm.number" placeholder="请输入数量" maxlength="7" width="100%"
                  oninput="value=value.replace(/[^\d]/g,'')"
                  onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="需要的积分:" prop="integral">
                <el-input v-model="addGoodsForm.integral" placeholder="请输入需要的积分" maxlength="7" width="100%"
                  @blur="(value) => {
                    getVal(value, 'integral');
                  }"
                  oninput="value=value.replace(/[^\d]/g,'')"
                  onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"/>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="+" prop="price" label-width="35px" style="text-align: center">
                <el-input v-model="addGoodsForm.price" placeholder="请输入需要的价格" maxlength="10" width="100%"
                  onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="addGoodsForm.type == 1">
            <el-col :span="24">
              <el-form-item label="送货方式:" prop="deliveryMode">
                <el-radio-group v-model="addGoodsForm.deliveryMode" @change="deliveryTypeChange" style="width: 100%">
                  <el-col :span="11">
                    <el-radio :label="1">快递送货&nbsp;
                      <el-input v-model="addGoodsForm.freight" placeholder="请输入运费，免运费输入0即可" maxlength="10" width="100%"
                        :disabled="addGoodsForm.deliveryMode == 2"
                        onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"/>
                    </el-radio>
                  </el-col>
                  <el-col :span="10">
                    <el-radio :label="2">客户到店自取&nbsp;
                      <el-input v-model="addGoodsForm.address" placeholder="请输取货地址" maxlength="50"
                        :disabled="addGoodsForm.deliveryMode == 1" width="100%"/>
                    </el-radio>
                  </el-col>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="说明:" prop="explain">
                <wjEditor :desc="addGoodsForm.explain" @change="contentChangeOne" style="width: 80%;"/>
              </el-form-item>
            </el-col>
          </el-row>
        </template>
      </el-form>
      <!-- :::::::::: 活动形式详情页 - 操作按钮 :::::::::: -->
      <div style="text-align: center;margin-bottom: 20px;">
        <el-button @click="cancelAdd">取消</el-button>
        <el-button type="danger" @click="saveAddGoods('addGoodsForm')">保存</el-button>
      </div>
    </div>
  </div>

  <!-- 换购记录 右侧抽屉组件 -->
  <el-drawer :title="exchangeRecordTitle" custom-class="registrationRecord"
    :visible.sync="exchangeRecord" direction="rtl" size="35%">
    <div class="dataDescription">
      <span>总换购记录：<b>{{ activeOrderTotal }}</b></span>
    </div>
    <el-table :data="exchangeRecordList" border>
      <el-table-column property="userName" label="用户昵称" align="center" />
      <el-table-column property="userPhone" label="手机号" align="center" />
      <el-table-column property="integral" label="消费积分数量" align="center"/>
      <el-table-column property="cTime" width="160px" label="支付时间" align="center" />
    </el-table>
    <!-- 活动订单-分页 -->
    <el-pagination layout="prev, pager, next" @current-change="handleCurrentChangehddd" :page-size="10"
    :current-page="activeOrderPageIndex" :total="activeOrderTotal" style="margin: 10px 0;float: right;"/>
  </el-drawer>

</section>
</template>
<script>
import alertTrends from '../../common/alertTrends.js';
import wjEditor from '../../components/MyWangEditor';
import { SelectBrandTypeBaseDataByCondition, provincegetcountys } from '../../api/newOss';
import { getkind, SelectGoodsBrandByBrandType, } from "../../api/api";
import { GetIntergralGoodsListByCondition, InsertIntegralGoods, UpdateIntegralGoods, GetIntegralGoodsById,
GetIntegralExchangeRecordList, BatchModifyIntegralGoodsIsOnSale, GetSortedIntegralGoodsList,
GetCascadeBrandBusinessCouponModel, getShopByCIty, getShopBrandType, getShopBrand, getShopBrandGoods} from "../../api/shopWindow";
export default {
  name: "PointsMallList",
  components: { wjEditor },
  mixins: [alertTrends],
  data() {
    return {
      itemfour: null,
      itemfourSourceGoodsId: null,
      changeID: null,
      exchangeRecordList: [], //活动订单列表
      optionExhibitions: [], //活动订单列表
      exchangeRecord: false, //活动订单列表
      pointsMallDia: false, //活动订单列表
      activeOrderPageIndex: 1, //活动订单分页页码
      activeOrderTotal: 0, //活动订单总数
      orderStatistics: {},
      exchangeRecordTitle: null, //换购记录标题
      couponsList: [], // 秒杀方式
      goodsList: [], // 秒杀方式
      brandTypearr: [],
      brandarr: [],
      newpinleiId:0,
      optionProps: {
        value: "id",
        label: "name",
        children: "ChildNodes",
      },
      optionCouponProps: {
        value: "id",
        label: "name",
        children: "ChildNodes",
      },
      goodsKey: 1,
      couponKey: 1,
      integralGoodsIdList: [], // 秒杀方式
      dada: [
         {
          value: 0,
          label: "全部",
        },
        {
          value: 1,
          label: "商品",
        },
        {
          value: 2,
          label: "优惠券",
        },
        {
          value: 3,
          label: "现金礼包",
        },
      ],
      addGoodsForm: {
        preCity: "",
        type: "",
        dianpu: '',
        dlpl: '',
        dlpp: '',
        shangpin: '',
        goods: "",
        faceValue: "",
        number: "",
        integral: "",
        price: null,
        couponId: "",
        deliveryMode: 1,
        freight: null,
        address: "",
        explain: "",
      },
      statedarr: [
        {
          Id: -1,
          Name: "全部",
        },
        {
          Id: 1,
          Name: "已上架",
        },
        {
          Id: 0,
          Name: "未上架",
        },
      ],
      form: {
        operatypeid: "",
        data1: "",
        data2: "",
        huikuanid: "",
      },
      hezuo: false,
      brandId1: 0,
      brandoptions: [],
      phone: "",
      brandId: 0,
      tbdcity: [],
      tbdprovince: [],
      provinceId: 0,
      cityId: 0,
      optionsindex: "",
      options: [], // 所属城市
      dianpuOptions: [], // 查询城市下有效店铺
      dlplOptions: [], // 获取店铺代理品类
      dlppOptions: [], // 获取店铺代理品牌
      shangpinOptions: [], // 获取店铺品类品牌下所有商品
      show3: true,
      iseditable: false,
      value6: "",
      userType: "",
      BbId: "",
      form: {},
      typenum: 1,
      isset: true,
      deleteId: "",
      dialogVisibledelete: false,
      brandAll: [],
      bloon1: false,
      bloon: true,
      showtime: true,
      ischeck: "",
      showBdName: false,
      xuanze: [],
      key1: "",
      // show:localStorage.checkedCities?true:false,
      agentBrandList: [],
      check: [],

      checkAll: false,
      checkedCities: [],

      cities: [],
      isIndeterminate: true,
      // 开关
      dialogVisible1: false,
      dialogVisible2: false,
      dialogVisible3: false,
      value4: true,
      dialogVisible: false,
      outerVisible: false,
      innerVisible: false,
      filters: {
        name: "",
        brandId: "",
        brandTypeId: "",
        type: 0,
        status: -1,
      },
      coperation: "",
      imageData: [],
      total: 100,
      page: 1,
      listLoading: false,
      isdelete: true,
      editFormVisible: false, //编辑界面显是否显示
      showImageUrl: "", // 二维码图片
      form: {
        ProvinceylId: 0,
        CityylId: 0,
        ZoneylId: 0,
        ZoneId: 0,
        TaxpayerAccount: "",
        address: "",
        name: "",
        Phone: "",
        OpeningBank: "",
        BankName: "",
        shopnum: "",
        accountName: "",
        BankNo: "",
        Contacts: "",
        ProvinceId: 0,
        CityId: 0,
        operatypeid: 1,
        date1: "",
        date2: "",
        OperatorId: "",
        huikuanid: 1,
        Contacts: "",
      },
      // banner是否显示
      isBanner: true,
      value1: "",
      orderarr: [
        {
          Id: 1,
          Name: "7天结算",
        },
        {
          Id: 2,
          Name: "订单完成时结算",
        },
      ],
      // 新增页面
      isAdd: false,
      pageIndex: 1,
      pageSize: 10,
      provinceoptions: "",
      provinceoptions1: "",
      cityoptions: [{ Id: 0, Name: "全部" }],
      cityoptions1: [{ Id: 0, Name: "全部" }],
      Zoneoptions: [{ Id: 0, Name: "全部" }],
      Zoneoptions1: [{ Id: 0, Name: "全部" }],
      enterfenyong: "",
      entergongchaung: "",
      yongjinid: "",
      save: true,
      editId: "",
      key: "",
      statusId: "",
      goodIdarr: [],
      BindWxStaffName: "",
      BindWxStaffPhone: "",
      brandStatus: "", // 状态
      huikuanoptions: "",
      hezuotype: "",
      hezuotime1: "",
      hezuotime2: "",
      huikuantype: "",
      translateLoading: false, // 生成品牌商绑定金专微信小程序推广二维码
      pickerOptions2: {
        disabledDate: (time) => {
          let beginDateVal = this.filters.date1;
          if (beginDateVal) {
            return (
              time.getTime() <
              new Date(beginDateVal).getTime() - 1 * 24 * 60 * 60 * 1000
            );
          }
        },
      },
    };
  },
  methods: {
    // 切换送货方式  只有商品类型为商品时显示
    deliveryTypeChange(val) {
      this.addGoodsForm.deliveryMode = val;
      if (this.addGoodsForm.deliveryMode == 1) {
        this.addGoodsForm.address = "";
      } else {
        this.addGoodsForm.freight = null;
      }
    },
    // 切换商品类型
    radioType(val) {
      this.couponKey++;
      this.goodsKey++;
      if(!this.addGoodsForm.preCity){
        this.addGoodsForm.type = '';
        this.showAlert('请选择所属城市');
        return false;
      }
      this.addGoodsForm.type = val;
      if (this.addGoodsForm.type == 1) {
        this.addGoodsForm.goods = "";
        this.addGoodsForm.deliveryMode = 1;
        this.addGoodsForm.freight = null;
        this.addGoodsForm.address = "";
        this.cxcsxyxdp(); // 查询城市下有效店铺
      } else if (this.addGoodsForm.type == 2) {
        this.addGoodsForm.couponId = "";
        this.getCascadeBrandBusinessCouponModel();
      } else if (this.addGoodsForm.type == 3) {
        this.addGoodsForm.faceValue = "";
      }
      this.addGoodsForm.number = "";
      this.addGoodsForm.integral = "";
      this.addGoodsForm.price = null;
      this.addGoodsForm.explain = "";
    },
    // 取消新增/编辑商品
    cancelAdd() {
      this.pointsMallDia = false;
      this.$refs.addGoodsForm.resetFields();
    },
    // 失去焦点时的事件
    getVal(val, name) {
      this.addGoodsForm[name] = val.target.value;
    },
    // 保存添加的商品信息
    saveAddGoods() {
      if (!this.addGoodsForm.preCity) {
        this.showAlert('请选择所属城市');
        return false;
      }
      if (!this.addGoodsForm.type) {
        this.showAlert('请选择商品类型');
        return false;
      }
      if (this.addGoodsForm.type == 1 && !this.addGoodsForm.goods) {
        this.showAlert('请选择商品');
        return false;
      }
      if (this.addGoodsForm.type == 2 && !this.addGoodsForm.couponId) {
        this.showAlert('请选择优惠券');
        return false;
      }
        if (this.addGoodsForm.type == 3 && Boolean(this.addGoodsForm.faceValue)==false) {
        this.showAlert('请输入现金礼包面值');
        return false;
      }
      if (this.addGoodsForm.type == 3 && this.addGoodsForm.faceValue<1) {
        this.showAlert('现金礼包面值最小值为1');
        return false;
      }
       if (this.addGoodsForm.type == 3 && (Number(this.addGoodsForm.faceValue)>9999999.99)) {
        this.showAlert('现金礼包面值最大值为9999999.99');
        return false;
      }
       if (Boolean(this.addGoodsForm.number)==false) {
        this.showAlert('请输入可兑换数量');
        return false;
      }
     if (this.addGoodsForm.number<1) {
        this.showAlert('可兑换数量最小值为1');
        return false;
      }
       if (Boolean(this.addGoodsForm.integral)==false) {
        this.showAlert('请输入需要的积分');
        return false;
      }
      if (this.addGoodsForm.integral<1) {
        this.showAlert('输入的需要积分最小值为1');
        return false;
      }
      // if (Boolean(this.addGoodsForm.price)==false) {
      //   this.showAlert('请输入需要的价格');
      //   return false;
      // }
      if(Boolean(this.addGoodsForm.price)!=false&&this.addGoodsForm.price!=0&&this.addGoodsForm.price<1){
        this.showAlert('如需换购价,则最小值为1');
        return false;
      }
      if(Number(this.addGoodsForm.price)>9999999.99){
        this.showAlert('换购价格不能超过9999999.99');
        return false;
      }
      if (this.addGoodsForm.type == 1 && !this.addGoodsForm.deliveryMode) {
        this.showAlert('请选择送货方式');
        return false;
      }
      if (
        this.addGoodsForm.type == 1 &&
        this.addGoodsForm.deliveryMode == 1 &&
        Boolean(this.addGoodsForm.freight)==false
      ) {
        this.showAlert('请输入运费');
        return false;
      }
        if (
        this.addGoodsForm.type == 1 &&
        this.addGoodsForm.deliveryMode == 1 &&
        Number(this.addGoodsForm.freight)>9999999.99
      ) {
        this.showAlert('运费最大值为9999999.99');
        return false;
      }
      if (
        this.addGoodsForm.type == 1 &&
        this.addGoodsForm.deliveryMode == 2 &&
        !this.addGoodsForm.address
      ) {
        this.showAlert('请输入取货地址');
        return false;
      }
      if (!this.addGoodsForm.explain) {
        this.showAlert('请输入额外说明');
        return false;
      }
      let params = {
        ...this.addGoodsForm,
        operatorId: localStorage.Id,
        provinceId: this.provinceId,
        cityId: this.cityId,
      };
      if (this.addGoodsForm.type == 1) {
        if(this.addGoodsForm.goods.length==4){
          this.goodsList.filter((item, index) => {
            if (item.id == this.addGoodsForm.goods[0]) {
              item.ChildNodes.filter((itemtwo, indextwo) => {
                if (itemtwo.id == this.addGoodsForm.goods[1]) {
                  itemtwo.ChildNodes.filter((itemthree, indexthree) => {
                    if (itemthree.id == this.addGoodsForm.goods[2]) {
                      itemthree.ChildNodes.filter((itemfour, indexthfour) => {
                        if (itemfour.id == this.addGoodsForm.goods[3]) {
                          this.itemfour = itemfour.goodsType;
                          this.itemfourSourceGoodsId = itemfour.sourceGoodsId;
                        }
                      });
                    }
                  });
                }
              });
            }
          });
        }
        params.goodsId = this.addGoodsForm.goods[3]||0;
        params.goodsType = this.itemfour||0;
        params.sourceGoodsId = this.itemfourSourceGoodsId||0;
        params.bbId = this.addGoodsForm.goods[0]||0;
        params.goodsBrandTypeId = this.addGoodsForm.goods[1]||0;
        params.brandId = this.addGoodsForm.goods[2]||0;
      } else if (this.addGoodsForm.type == 2) {
        if(this.addGoodsForm.couponId.length==4){
          this.couponsList.filter((item, index) => {
            if (item.id == this.addGoodsForm.couponId[0]) {
              item.ChildNodes.filter((itemtwo, indextwo) => {
                if (itemtwo.id == this.addGoodsForm.couponId[1]) {
                  itemtwo.ChildNodes.filter((itemthree, indexthree) => {
                    if (itemthree.id == this.addGoodsForm.couponId[2]) {
                      itemthree.ChildNodes.filter((itemfour, indexthfour) => {
                        if (itemfour.id == this.addGoodsForm.couponId[3]) {
                          this.itemfour = itemfour.goodsType;
                          params.goodsType = itemfour.goodsType;
                          this.itemfourSourceGoodsId = itemfour.sourceGoodsId;
                          params.sourceGoodsId = this.itemfourSourceGoodsId;
                        }
                      });
                    }
                  });
                }
              });
            }
          });
        }
        params.goodsId = this.addGoodsForm.couponId[3]||0;
        params.goodsType = this.itemfour||0; // 商品类型；0=现金礼包，1=探店商品；2=活动商品；3=优惠券
        params.sourceGoodsId = this.itemfourSourceGoodsId||0;
        params.bbId = this.addGoodsForm.couponId[0]||0; //所属品牌商id
        params.goodsBrandTypeId = this.addGoodsForm.couponId[1]||0; //所属品类id
        params.brandId = this.addGoodsForm.couponId[2]||0; //所属品牌id
      } else if (this.addGoodsForm.type == 3) {
        params.goodsType = 0;
        params.bbId = 0;
        params.goodsBrandTypeId = 0;
        params.brandId = 0;
      }
      this.$delete(params, "config");
      if (this.pointsType) {
        //true 新增进入的    false 通过编辑进入的
        InsertIntegralGoods(params).then((res) => {
          if (res.ResultCode == 1) {
            this.pointsMallDia = false;
            this.init();
            this.showAlert('操作成功', 'success');
          }
        });
      } else {
        // 编辑
        UpdateIntegralGoods(params).then((res) => {
          if (res.ResultCode == 1) {
            this.pointsMallDia = false;
            this.init();
            this.showAlert('操作成功', 'success');
          }
        });
      }
    },
    // 编辑积分商城
    eidtPointsMall(type, scope) {
      this.pointsType = type; //true 新增进入的    false 通过编辑进入的
      if (!this.pointsType) {
        //编辑--查看详情回显
        let params = {
          integralGoodsId: scope.id,
        };
        GetIntegralGoodsById(params).then((res) => {
          if (res.ResultCode == 1) {
            var arrChoose = [
              res.ResultObj.bbId,
              res.ResultObj.goodsBrandTypeId,
              res.ResultObj.brandId,
              res.ResultObj.goodsId,
            ];
            this.addGoodsForm = res.ResultObj;
            this.addGoodsForm.price=this.addGoodsForm.price.toString();
            this.provinceId = res.ResultObj.provinceId;
            this.cityId = res.ResultObj.cityId;
            if (res.ResultObj.type == 1) {
              this.$nextTick((res) => {
                this.addGoodsForm.goods = arrChoose;
                this.addGoodsForm.freight = this.addGoodsForm.freight.toString();
                this.$set(this.addGoodsForm, "goods", arrChoose);
                this.$forceUpdate();
              });
            } else if (res.ResultObj.type == 2) {
              this.getCascadeBrandBusinessCouponModel();
              // this.addGoodsForm.couponId = [
              //   res.ResultObj.bbId,
              //   res.ResultObj.goodsBrandTypeId,
              //   res.ResultObj.brandId,
              //   res.ResultObj.couponId,
              // ];
               this.$nextTick((res) => {
                this.addGoodsForm.couponId = arrChoose;
                this.$set(this.addGoodsForm, "goods", arrChoose);
                this.$forceUpdate();
              });
            }
            this.pointsMallDia = true;
            this.addGoodsForm.preCity = [this.provinceId, this.cityId];
          }
        });
      } else {
        this.pointsMallDia = true;
        this.$nextTick((res) => {
          this.addGoodsForm.preCity = "";
          this.addGoodsForm.type = "";
          this.addGoodsForm.goods = "";
          this.addGoodsForm.faceValue = "";
          this.addGoodsForm.number = "";
          this.addGoodsForm.integral = "";
          this.addGoodsForm.price = null;
          this.addGoodsForm.couponId = "";
          this.addGoodsForm.deliveryMode = "";
          this.addGoodsForm.freight = null;
          this.addGoodsForm.address = "";
        });
      }
    },
    // 上架 1 or 下架 0
    goodsIsOnSale(type) {
      let params = {
        integralGoodsIds: this.integralGoodsIdList,
        state: type,
      };
      BatchModifyIntegralGoodsIsOnSale(params).then((res) => {
        if (res.ResultCode == 1) {
          this.showAlert('操作成功', 'success');
          this.integralGoodsIdList=[];
          this.init();
        }
      });
    },
    // 换购记录
    exchangeNum(scope) {
      if (scope.exchangeCount == 0) {
        return;
      }
      this.changeID=scope.id;
      this.exchangeRecord = true;
      this.activeOrderPageIndex=1;
      this.exchangeRecordTitle = `${scope.name}换购记录`;
      this.integralExchangeRecordList(scope.id);
      
    },
    //  获取换购记录统计
    integralExchangeRecordList(id) {
      var obj = {
        integralGoodsId: id,
        pageIndex:this.activeOrderPageIndex, //活动订单分页页码
        pageSize:10,
      };
      GetIntegralExchangeRecordList(obj).then((res) => {
        if (res.ResultCode == 1) {
          this.exchangeRecordList = res.ResultObj;
          this.activeOrderTotal = res.RowsCount;
        } else {
          this.exchangeRecordList = [];
          this.activeOrderTotal = 0;
        }
      });
    },
    // 查询活动订单分页
    handleCurrentChangehddd(val) {
      this.activeOrderPageIndex = val;
      this.integralExchangeRecordList(this.changeID);
    },
    // 查询列表
    init() {
      let that = this;
      let params = {
        keyword: this.filters.name,
        state: this.filters.status,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        goodsBrandTypeId: this.filters.brandTypeId,
        type: this.filters.type,
        brandId: this.filters.brandId,
      };
      GetIntergralGoodsListByCondition(params).then((data) => {
          this.total = data.RowsCount;
          data = data.ResultObj;
          for (var obj of data) {
            if (obj.StatusId == 1) {
              obj.open = true;
            } else {
              obj.open = false;
            }
          }
          this.imageData = data;
        })
        .catch((err) => {
          this.imageData = [];
        });
    },
    // 优惠券下拉列表
    getCascadeBrandBusinessCouponModel() {
      let params = {
        cityId: this.cityId,
      };
      GetCascadeBrandBusinessCouponModel(params).then((data) => {
        this.couponsList = data.ResultObj;
      })
      .catch((err) => {
        this.couponsList = [];
      });
    },

    //操作向上   向下
    upordown(val, scope) {
      var obj = {
        integralGoodsId: scope.id,
        direction: val,
      };
      GetSortedIntegralGoodsList(obj).then((res) => {
        if (res.ResultCode == 1) {
          this.init();
        }
        if (res.ResultCode == 0) {
          this.showAlert(res.ResultMsg, 'error');
        }
        if (res.ResultCode == 2) {
          this.showAlert(res.ResultMsg, 'error');
        }
      });
    },

    //点击复选框
    handleSelectionChange(val) {
      if (val.length == 1) {
        this.hezuotype = val[0].CooperationTypeId;
        this.hezuotime1 =
          val[0].CoStarTime + "" == "null" ? "" : val[0].CoStarTime;
        this.hezuotime2 =
          val[0].CoEndTime + "" == "null" ? "" : val[0].CoEndTime;
        this.value1 = [this.hezuotime1, this.hezuotime2];
        this.huikuantype = val[0].SettleTypeId;
      } else {
        this.hezuotype = 0;
        this.hezuotime1 = "";
        this.hezuotime2 = "";
        this.huikuantype = 1;
        this.value1 = [];
      }
      this.goodIdarr = [];
      this.goodNamearr = [];
      val.forEach((element) => {
        this.integralGoodsIdList.push(element.id);
        // this.BindWxStaffName = element.BindWxStaffName;
        // this.BindWxStaffPhone = element.BindWxStaffPhone;
      });
    },

    //获取品牌
    getbrand() {
      let that = this;
      var loginParams = {
        tableName: "tbdbrand",
        keyWord: "",
        parentId: "",
      };
      getkind(loginParams)
        .then((data) => {
          data = data.ResultObj;

          var obj = {
            Id: 0,
            Name: "全部",
          };
          data.unshift(obj);
          that.brandoptions = data;
        })
        .catch((err) => {
          this.logining = false;
        });
    },
    // 查找省+市
    getprovince() {
      var loginParams = {
        isopen: -1, // 是否开放 -1=查全部 1=开放、0=未开放
      };
      provincegetcountys(loginParams).then(data => {
        let that = this;
        let cityList = [];
        data.resultObj.forEach(item => {
          let cityData = { value: item.pid, label: item.pname, children: [] };
          cityList.push(cityData);
          item.citys.map(city => {
            cityData.children.push({ value: city.cid, label: city.cname });
          });
        });
        that.options = cityList;
      })
    },

    // 查询列表页所属城市
    handleChange(val) {
      this.provinceId = val[0];
      this.cityId = val[1];
      if (this.addGoodsForm.type == 1) {
        this.goodsKey++;
        this.addGoodsForm.goods = "";
      } else if (this.addGoodsForm.type == 2) {
        this.couponKey++;
        this.addGoodsForm.couponId = "";
        this.getCascadeBrandBusinessCouponModel();
      }
    },
    // 选中商品
    handleGoodsChange(val) {
      this.addGoodsForm.goods = val;
    },
    // 选中优惠券
    handleCouponsChange(val) {
      this.addGoodsForm.couponId = val;
    },
    // 重置
    fnReset() {
      this.filters = {
        name: "",
        brandId: "",
        brandTypeId: "",
        type: 0,
        status: -1,
      };
      this.pageIndex = 1;
      this.init();
    },
    // 查询
    onSubmit() {
      this.pageIndex = 1;
      this.init();
    },
    hide() {
      this.$refs.mySelect.handleClose();
    },
    setting(scope) {
      this.dialogVisible = true;
      this.isset = true;
      this.yongjinid = scope.Id;
      this.entergongchaung = scope.GcdPriceRate;
      this.enterfenyong = scope.PriceRate;
    },

    handleCurrentChange(val) {
      this.pageIndex = val;
      this.init();
    },

    // 获取品牌
    getbrandarr() {
      this.filters.brandId = 0
        var obj = {
          userId: localStorage.Id,
          brandTypeId: this.filters.brandTypeId
        };
        SelectGoodsBrandByBrandType(obj).then(data => {
          if (data.ResultCode == 1) {
            this.brandarr = data.ResultObj;
            this.brandarr.unshift({
              Id: 0,
              Name: "全部"
            });
          }
        });
      
    },
    // 获取品类
    getBrandType() {
      var obj = {
        userId: localStorage.Id
      };
      SelectBrandTypeBaseDataByCondition(obj).then(data => {
        if (data.ResultCode == 1) {
          this.brandTypearr = data.ResultObj;
          this.newpinleioptions = data.ResultObj;
          this.brandTypearr.unshift({
            Id: 0,
            Name: "全部"
          });
        }
      });
    },
    // 说明
    contentChangeOne(content) {
      this.addGoodsForm.explain = content;
    },
    // 查询城市下有效店铺
    cxcsxyxdp() {
      var addParams = {
        cityId: this.cityId, // 城市id
      };
      getShopByCIty(addParams).then(data => {
        this.dianpuOptions = data.resultObj;
      });
    },
    changeDp(val) {
      this.addGoodsForm.dianpu = val;
      this.addGoodsForm.dlpl = '';
      this.addGoodsForm.dlpp = '';
      this.addGoodsForm.shangpin = '';
      if(this.addGoodsForm.dianpu) {
        this.hqdpdlpl();
      }
    },
    // 获取店铺代理品类
    hqdpdlpl() {
      var addParams = {
        bbid: this.addGoodsForm.dianpu, // 店铺id
      };
      getShopBrandType(addParams).then(data => {
        this.dlplOptions = data.resultObj;
      });
    },
    changepl(val) {
      this.addGoodsForm.dlpl = val;
      if(this.addGoodsForm.dlpl) {
        this.hqdpdlpp();
      }
    },
    // 获取店铺代理品牌
    hqdpdlpp() {
      var addParams = {
        bbid: this.addGoodsForm.dianpu, // 店铺id
        brandTypeId: this.addGoodsForm.dlpl, // 品类id
      };
      getShopBrand(addParams).then(data => {
        this.dlppOptions = data.resultObj;
      });
    },
    changepp(val) {
      this.addGoodsForm.dlpp = val;
      if(this.addGoodsForm.dlpp) {
        this.hqdpplplxsysp();
      }
    },
    // 获取店铺品类品牌下所有商品
    hqdpplplxsysp() {
      var addParams = {
        bbid: this.addGoodsForm.dianpu, // 店铺id
        brandTypeId: this.addGoodsForm.dlpl, // 品类id
        brandId: this.addGoodsForm.dlpp, // 品牌id
      };
      getShopBrandGoods(addParams).then(data => {
        this.shangpinOptions = data.resultObj;
      });
    },
    
  },
  mounted() {
    this.form.OperatorId = this.$cookie.get("OperatorId");
    this.init();
    this.getprovince();
    this.userType = localStorage.UserType;
    this.BbId = localStorage.BbId;
    this.getBrandType(); //获取品类
    // this.getbrand();
    // this.cxcsxyxdp(); // 查询城市下有效店铺
  },
 
  watch: {
    menuAction: function (val) {
      this.menuAction = val;
    },
    goodsList: function (val) {
      this.goodsKey++;
    },
    couponsList: function (val) {
      this.couponKey++;
    },
  },
};
</script>
<style scoped>
.is-checked .el-checkbox__label {
  color: #606266;
}
.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #606266;
}
.overflow .el-checkbox__label {
  width: 80px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.table_container .el-table__fixed-right {
  height: 628px !important;
}
.el-input__inner {
  background-color: #fff;
  border: 1px solid #f2f2f2;
}
.button {
  background: #fff;
  border: 1px solid #F56C6C;
  color: #F56C6C;
}
.button:hover {
  background: #F56C6C;
  border: 1px solid #F56C6C;
  color: #fff;
}
.allchange {
  height: 35px;
  background: #f6f7f9;
  padding-left: 20px;
  margin-top: 30px;
}
.check_box {
  padding-left: 15px;
  height: 200px;
  overflow: hidden;
  overflow-y: scroll;
}
.shezhi {
  width: 80px;
  /* overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis; */
}
.bdname {
  width: 100%;
  height: 35px;
  line-height: 35px;
  background: #dedede;
  margin-top: 20px;
}
.span {
  display: inline-block;
  width: 60px;
  height: 35px;
  line-height: 35px;
  border: 1px solid #F56C6C;
  text-align: center;
  color: #F56C6C;
  border-radius: 5px;
  margin-left: 15px;
}
.span:hover {
  background: #F56C6C;
  color: #fff;
  transform: 1s;
}
.span {
  display: inline-block;
  width: 60px;
  height: 35px;
  line-height: 35px;
  border: 1px solid #F56C6C;
  text-align: center;
  color: #F56C6C;
  border-radius: 5px;
  margin-left: 15px;
}
.span:hover {
  background: #F56C6C;
  color: #fff;
  transform: 1s;
}
.span1 {
  display: inline-block;
  width: 50px;
  height: 20px;
  line-height: 20px;
  background: #F56C6C;
  color: #fff;
  text-align: center;

  margin-left: 0px;
}

.fu_hao {
  color: #bebebe;
  margin-left: 5px;
}
.input_item {
  margin-bottom: 15px;
}
.input_item label {
  width: 120px;
  text-align: right;
  display: inline-block;
  color: #bebebe;
  font-size: 12px;
}
.confirm_btn {
  background: #F56C6C;
  color: #fff;
  border-color: #F56C6C;
}
.cancle_btn {
  border-color: #F56C6C;
  color: #F56C6C;
}
.red {
  color: #F56C6C;
}
.banner .toolbar {
  height: auto;
}
/* 时间  */
/* .toolbar .line {
  margin-left: 20px;
  line-height: 36px;
} */
/* 时间图标 */
/* .toolbar .line img{
  margin-top:8px
} */
.toolbar .el-button {
  background-color: #F56C6C;
  margin-left: 0;
  color: #fff;
  width: 78px;
}
/* 内容表格 */
.banner_table {
  background-color: #ffffff;
  box-shadow: 0px 1px 10px 0px rgba(14, 5, 10, 0.1);
  margin-top: 10px;
  height: 640px;
  position: relative;
  /* overflow: hidden;
   */
}
/* 标题 */
.banner_table section {
  height: 55px;
  line-height: 55px;
  border-bottom: 1px solid #eee;
}
.banner_table .el-col-22 p {
  width: 86px;
  height: 55px;

  font-size: 14px;
  font-weight: bold;
  color: #2a2a2a;
  margin-left: 22px;
  line-height: 55px;
  border-bottom: 1px solid #F56C6C;
  margin-top: 0;
}
/* 新增按钮 */
.banner_table .el-col-2 p {
  width: 104px;
  height: 36px;
  background-color: #F56C6C;
  line-height: 36px;
  text-align: center;
  color: #fff;
  border-radius: 3px;
  cursor: pointer;
}
/* 表格 */
.ban_tab {
  box-shadow: 0 0 0 0;
  width: 100%;
  margin: 0 auto;
}
/* 表格操作 */
.ban_tab p {
  float: left;

  margin-left: 10%;
}
.qRCode {
  width: 230px;
  height: 36px;
  line-height: 36px;
  background-color: #F56C6C;
  text-align: center;
  color: #fff;
  border-radius: 3px;
  cursor: pointer;
}
.imgDialog {
  width: 100%;
  height: 360px;
  margin: 0 auto;
  text-align: center;
}
.imgDialog > img {
  width: auto;
  height: auto;
  max-width: 90%;
  max-height: 90%;
}
.imgDialog > p {
  width: 100%;
  height: 50px;
  font-size: 16px;
}
/* 新增页面 */
.add_banner {
  background-color: #ffffff;
  box-shadow: 0px 1px 10px 0px rgba(14, 5, 10, 0.1);
  margin-top: 20px;
  padding-bottom: 30px;
  position: relative;
}
.add_banner .el-col-24 {
  border-bottom: 1px solid #eee;
  margin-bottom: 20px;
}
.add_banner .el-col-24 p {
  width: 110px;
  height: 55px;

  font-size: 14px;
  font-weight: bold;
  color: #2a2a2a;
  margin: 0;
  margin-left: 40px;
  line-height: 55px;
  border-bottom: 1px solid #F56C6C;
}
.add_banner input {
  border: 1px solid #f2f2f2;
  background: #fff !important;
}
</style>



// WEBPACK FOOTER //
// PointsMallList.vue?0dd46b6a